module.exports = __webpack_public_path__ + "img/sol_isol_pain1.c04a74cd.png";